var map = {
	"./001.png": 355,
	"./002.png": 356,
	"./003.png": 357,
	"./004.png": 358,
	"./005.png": 359,
	"./006.png": 360,
	"./007.png": 361,
	"./008.png": 362,
	"./009.png": 363,
	"./010.png": 364,
	"./011.png": 365,
	"./012.png": 366,
	"./013.png": 367,
	"./014.png": 368,
	"./015.png": 369,
	"./016.png": 370,
	"./017.png": 371,
	"./018.png": 372,
	"./019.png": 373,
	"./020.png": 374,
	"./021.png": 375,
	"./022.png": 376,
	"./023.png": 377,
	"./024.png": 378,
	"./025.png": 379,
	"./026.png": 380,
	"./027.png": 381,
	"./028.png": 382,
	"./029.png": 383,
	"./030.png": 384,
	"./031.png": 385,
	"./032.png": 386,
	"./033.png": 387,
	"./034.png": 388,
	"./035.png": 389,
	"./036.png": 390,
	"./037.png": 391,
	"./038.png": 392,
	"./039.png": 393,
	"./040.png": 394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 354;